import { Button, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import { userSelector } from "../../../user-redux/selector";
import { updateSubmissionsAction } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { myCandidatesSelector } from "../../redux/selector";

// Accept Profile Manually
const Step4 = () => {
  let dispatch = useDispatch();
  const { candidateDetails, jobDetails, selectedSubmission } =
    useSelector(myCandidatesSelector);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleToastClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    let updatedData = {
      candidateid: selectedSubmission?.candidate_id,
      jobid: selectedSubmission?.job_id,
      userid: selectedSubmission.user_id,
      status: "5",
    };
    dispatch(
      updateSubmissionsAction(
        updatedData,
        selectedSubmission.user_id,
        selectedSubmission?.candidate_id,
        selectedSubmission?.job_id
      )
    )
      .then(() => {
        handleOpenSnackbar(
          "Profile Manually Accepted Successfully!",
          "success"
        );
        setIsSubmitting(false);
        // Step4 will automatically move to Step5 when the submission status 
        // is updated to "Rate Confirmation" and the useEffect in SubmissionFlow.js 
        // detects the status change and updates activeStep to 3
      })
      .catch((error) => {
        console.error(error);
        handleOpenSnackbar("Something went wrong!", "error");
        setIsSubmitting(false);
      });
    // dispatch(getSubmissionsByJobAction( selectedSubmission.user_id , selectedSubmission?.candidate_id , selectedSubmission?.job_id))

    //   setState({ isPaneOpen: false });
    // props.handleNext();
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "30px",
      }}
    >
      <Button
        variant="outlined"
        sx={{
          "&:hover": {
            backgroundImage:
              "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
            color: "#fff",
            border: "none",
          },
        }}
        onClick={handleSubmit}
        disabled={selectedSubmission?.bench_status_id !== 3}
      >
        {isSubmitting ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Accept Profile Manually"
        )}
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleToastClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default Step4;
